export const errorCodeToText = {
	404: 'The requested resource was not found.',
	500: 'An unexpected error encountered when connecting to the server.'
}